import { TOrderEntryHazmat } from '../../Hazmat/types'

export default function getDefaultHazmat(): TOrderEntryHazmat {
  return {
    transportCategory: undefined,
    packagingGroup: undefined,
    unit: 'kg',
    class: undefined,
    tunnelLimitation: undefined,
    environmentalHazard: undefined,
    limitedQuantityEnabled: undefined,
    count: 1,
    release: '2023',
    amount: 0,
    packaging: '',
    unNumber: '',
    points: 0,
  }
}
